<template>
  <section class="single-page-signup-hero-banner row mx-0">
    <trust-pilot-single-page :id="id" />
    <div class="col-8 col-md-8 col-xl-6 pl-0">
      <h1 class="single-page-signup-hero-banner-title">
        Delicious coffee,<br>unbeatable freshness
      </h1>
      <p class="single-page-signup-hero-banner-subtitle">
        The world's best coffee,<br class="desktop-md"> roasted to order. From just £8.95.
      </p>
    </div>
  </section>
</template>

<script setup>
import TrustPilotSinglePage from '../elements/TrustPilotSinglePage.vue'
const props = defineProps({
  id: {
    type: String,
    required: true,
  }
})
</script>

<script>
export default {
  name: 'HeroBanner',
}
</script>

<style lang="scss" scoped>

.single-page-signup-hero-banner {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  background-image: url('https://res.cloudinary.com/pactcoffee/image/upload/f_auto,q_auto/v1786000127/website-d2c/assets/kopi/coffee-plans/single-page-funnel-hero.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 230px;

  @media (min-width: 356px) and (max-width: 399px) {
    height: calc(100vw * 255 / 320);
    background-position: right;
  }

  @media (min-width: 400px) and (max-width: 575px) {
    height: calc(100vw * 300 / 400);
    background-position: right;
  }

  @media (min-width: 576px) and (max-width: 767px) {
    height: calc(100vw * 310 / 576);
    background-position: right;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    height: calc(100vw * 415 / 768);
    background-position: right;
  }

  @media(min-width: 400px){
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    height: 350px;
  }

  @media (min-width: 1200px) and (max-width: 1499px) {
    height: 380px;
  }

  @media (min-width: 1500px) {
    height: 420px;
  }

  &-title {
    color: #FFF;
    font-family: 'Apercu';
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 5px;

    @media (min-width: 320px) and (max-width: 399px) {
      font-size: 18px;
      line-height: 20px;
    }

    @media (min-width: 430px) and (max-width: 767px) {
      font-size: 22px;
      line-height: 28px;
    }

    @media (min-width: 768px) {
      font-size: 26px;
      line-height: 32px;
      margin-bottom: 10px;
    }
  }

  &-subtitle {
    color: #FFF;
    font-family: 'Apercu';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px;
    margin-bottom: 0px;
    letter-spacing: 0px;

    @media (min-width: 320px) and (max-width: 399px) {
      font-size: 14px;
      line-height: 18px;
    }
  }

  .trustpilot-mini-widget {
    @media (min-width: 768px) {
      max-width: 300px;
      margin: auto;
    }
  }
}
</style>
